import React from "react";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../utility/constants";
import { DecisionSwal } from "../../../../../../../Utils/Utils/DecisionSwal";
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");
const stopIcon = require("assets/img/icons/stop.png");

export const ActionsContent = (props) => {
    const {
        index,
        item,
        EliminarOrdenProduccion,
        setOrdenEdicion,
        CompletarOrdenProduccion,
    } = props;

    const MostrarMensajeDetenerProduccion = (item) => {
        let mensaje =
            "¿Está seguro que desea detener esta orden de producción con el estado actual?";

        mensaje +=
            " Luego de guardar los cambios esta acción no se podrá revertir.";

        DecisionSwal(mensaje, "Sí", "No", () => CompletarOrdenProduccion(item.id));
    };

    const estado = item && item.estado;

    if (estado == ESTADOS_ORDEN_PRODUCCION.PENDIENTE) {
        return (
            <div className="table-actions">
                <img
                    src={eliminarIcon}
                    alt="Eliminar"
                    className="action_img"
                    title="Eliminar"
                    onClick={() => EliminarOrdenProduccion(item.id)}
                />
            </div>
        );
    } else if (estado == ESTADOS_ORDEN_PRODUCCION.EN_PROCESO) {
        return (
            <div className="table-actions">
                <img
                    src={editarIcon}
                    alt="Editar kg"
                    className="action_img"
                    title="Editar kilogramos"
                    onClick={() => setOrdenEdicion(item)}
                />
                <img
                    src={stopIcon}
                    alt="Detener producción"
                    className="action_img"
                    title="Detener producción"
                    onClick={() => MostrarMensajeDetenerProduccion(item)}
                    style={{ width: "26px", height: "26px" }}
                />
            </div>
        );
    } else {
        return <span>—</span>;
    }
};
